import { CITIES } from "./specialties";
import { CITY_DETAILS } from "./cityDetails";

export const SITE_URL = "https://coach-sportif-fasciatherapie.fr";
export const DEFAULT_IMAGE = "https://static.wixstatic.com/media/47ea5f_c703aa75f7ae4360ba27023c67e111bf~mv2.jpg";
export const DEFAULT_TITLE = "Fasciathérapie & Sport Santé — Jean-Christophe Happillon à Toulouse";
export const DEFAULT_DESCRIPTION =
  "Fasciathérapie à domicile à Toulouse (méthode Tissual Balancing) & coaching sport santé. Soulagez vos douleurs chroniques et retrouvez la mobilité. Bilan gratuit.";

export const fullTitle = (title) => (title ? `${title} — Fasciathérapie & Sport Santé` : DEFAULT_TITLE);

export const PAGE_META = {
  "/": {
    title: "Fasciathérapie & Coaching sportif à domicile à Toulouse",
    description: "Fasciathérapie à domicile à Toulouse (méthode Tissual Balancing) et coaching sport santé. Soulagez vos douleurs, retrouvez la mobilité. Bilan gratuit.",
  },
  "/fasciathérapie-toulouse": {
    title: "Fasciathérapie Toulouse — Soulagez vos douleurs chroniques",
    description: "Fasciathérapie à Toulouse (méthode Tissual Balancing) : soulagez vos douleurs chroniques (dos, cervicales, hanches, chevilles, genoux) avec des séances à domicile.",
  },
  "/coach-domicile": {
    title: "Coach sportif à domicile à Toulouse — Bilan gratuit",
    description: "Coach sportif à domicile à Toulouse et environs. Séances personnalisées sport-santé, remise en forme, douleurs chroniques. 50% de réduction grâce au crédit d'impôt.",
  },
  "/tarifs": {
    title: "Tarifs fasciathérapie & coaching sportif à Toulouse",
    description: "Fasciathérapie dès 60€ et coaching sportif dès 20€ (crédit d'impôt 50%). Séances sans engagement à Toulouse. Bilan gratuit offert.",
  },
  "/blog": {
    title: "Blog conseils douleurs, mobilité et sport santé à Toulouse",
    description: "Articles sur la fasciathérapie, le sport santé, la mobilité et les douleurs chroniques à Toulouse, Saint-Orens, Balma, Labège, Montaudran.",
  },
  "/contact": {
    title: "Contact — Fasciathérapie & Sport Santé à Toulouse",
    description: "Contactez Jean-Christophe Happillon, fasciathérapeute et coach sportif à Toulouse. Bilan gratuit offert. Séances à domicile ou au cabinet de Saint-Orens.",
  },
  "/mentions-légales": {
    title: "Mentions légales",
    description: "Mentions légales du site Fasciathérapie & Sport Santé à Toulouse.",
  },
};

export const cityMeta = (slug) => {
  const city = CITIES.find((c) => c.slug === slug);
  const name = city.short || city.name;
  return {
    title: `Fasciathérapie ${name} & coach sport-santé à domicile`,
    description:
      CITY_DETAILS[slug]?.metaDescription ||
      `Fasciathérapie (méthode Tissual Balancing) et coach sport-santé à domicile à ${name} (${city.cp}). Douleurs chroniques, mobilité. Bilan gratuit.`,
  };
};
